import { Component, OnInit } from '@angular/core';
import { CommsService } from '../../services/comms/comms.service';
import { NoteService } from '../../services/note/note.service';
import { DisplayService } from '../../services/display/display.service';

@Component({
	selector: 'pcm-timesheet-line-item',
	templateUrl: './timesheet-line-item.component.html',
	styleUrls: ['./timesheet-line-item.component.scss']
})
export class TimesheetLineItemsComponent implements OnInit {

	lineItems: Array<any> = [];

	constructor(
		private commsService: CommsService,
		private noteService: NoteService,
		private displayService: DisplayService
	) {}

	ngOnInit() {
		this.commsService.getLineItem('LINEITEMS').subscribe(res => {
			this.lineItems = [];
			if (res.detail.value) {
				this.lineItems.push(... res.detail.value);
			}
		}, err => {
			console.log(err);
			this.noteService.displayError('Error occurred during retriving line items');
		});
	}

	onSave() {
		// dont save line item with blank value
		this.lineItems = this.lineItems.filter(line => line.value !== '');
		this.displayService.startLoading();
		this.commsService.saveLineItems(this.lineItems, 'LINEITEMS').subscribe(res => {
			this.displayService.clearLoading();
			this.noteService.displaySuccess('Line items have been successfully saved');
		}, err => {
			console.log(err);
			this.noteService.displayError('Error occurred during saving line items');
		});
	}

	addLineItem() {
		this.lineItems.push({'active': true, 'value': ''});
	}

	deletelineItem(index) {
		this.lineItems.splice(index, 1);
	}
}
